import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { StudentSchoolEnrollmentService } from '../../../service/student-school-enrollment.service';
import { SchoolEnrollment, SchoolEnrollments } from '../model/ina-school-enrollments';
import { INAAction } from '../model/ina-action';
import moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription, map } from 'rxjs';
import { InaService } from '../service/ina.service';
import { InaSchoolEnrollmentSelection, LstQuestionValueDataView, Section } from '../model/ina-school-enrollment-sections';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmChangesComponent } from 'src/app/component/common-components/confirm-changes/confirm-changes.component';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { Shared } from '../service/shared';


import { LoginTokenService } from 'src/app/service/login-token.service';
import { User } from 'src/app/component/auth/model/user.model';
import { TrackingHistories, TrackingHistory } from '../service/history';
import { formatDate } from '@angular/common';
import { ThemePalette } from '@angular/material/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { ApiExportsService } from 'src/app/service/api-exports.service';
import { ProgressSpinnerSet, UtilityService } from 'src/app/service/utility.service';
import { LearningPlanComponent } from './learning-plan/learning-plan.component';
import { ServiceName } from './model/serviceName';





@Component({
  selector: 'app-edit-ina',
  templateUrl: './edit-ina.component.html',
  styleUrls: ['./edit-ina.component.scss']
})
export class EditINAComponent implements OnInit {
  @ViewChild(LearningPlanComponent) learningplan!: LearningPlanComponent;
  @Input() searchParm: any = [{}];

  inaId: number;
  studentId: number;
  schoolEnrollmentId: number;
  step: number = 1;
  showSections: boolean = false;
  frmIna: UntypedFormGroup;

  schOriginalEnrollments: SchoolEnrollments;
  results: SchoolEnrollment[] = [];
  schEnrollments: SchoolEnrollment[] = [];
  selectedSchoolYear: string = '';

  resetField: boolean = false;
  loading: boolean = true;

  startingSchoolYearDate: Date;

  action: INAAction;
  inaSchoolEnrollmentSelection: InaSchoolEnrollmentSelection = new InaSchoolEnrollmentSelection();
  inaFormValid = new Array<INAFormValid>();
  shared: Shared;
  lstTrackHistory: TrackingHistory[] = [];

  trackHistories: TrackingHistories = new TrackingHistories();
  horizontalPosition: MatSnackBarHorizontalPosition = 'start';
  verticalPosition: MatSnackBarVerticalPosition = 'bottom';

  bCheckedStyling: boolean = true;
  strExportFileName = 'INA_ILP';
  fileNameLabel: string = '';
  latestFileToOpen: string = '';
  currentSetting: any;
  // progress bar props
  progressCurrentValue: number = 1; //10
  progressValue: number = .005;
  progressMax: number = 500; //500;
  progressSpinnerMax: number = 100;// 500
  progressColor: ThemePalette = 'accent';
  progressType: ProgressSpinnerMode = 'determinate';
  progressSpeed: number = 1; //10
  progressSubscription: Subscription;
  progressInterval: number = 500;

  // learning plan recommendations
  lpRecommendedServices: ServiceName[] = [];
  lpRecommendedSupportServices: ServiceName[] = [];

   settings: any = {
        '/reports/student-service-lists': {
            TITLE: 'Ina Ilp Report',
            EXPORTFILENAME: 'INA_ILP',
            API: undefined,
            SCHOOL_YEAR: true,
            QUESTION_HELP_TEXT_ID: 248,
        }
    };
    
  constructor(
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private studentSchoolEnrollmentService: StudentSchoolEnrollmentService,
    private inaService: InaService,
    private loginTokenService: LoginTokenService,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private apiMsinExportsService: ApiExportsService,
    private utilityService: UtilityService,
  ) {

    this.shared = new Shared(inaService);
    const inaId: Observable<string> = route.params.pipe(map((p) => p['inaId']));
    inaId.subscribe((x) => { this.inaId = parseInt(x) });
    const studentId: Observable<string> = route.params.pipe(map((p) => p['childId']));
    studentId.subscribe((x) => { this.studentId = parseInt(x) });

    this.frmIna = this.fb.group({
      schoolYears: new UntypedFormControl(['', Validators.required]),
      schoolEnrollment: ['', Validators.required],
      radioINAILP: ['', Validators.required],
    })

    route.data.subscribe(x => {
      if (x['action'] == 'edit') {
        this.action = INAAction.Edit;
        this.frmIna.disable();
      }
      else if (x['action'] == 'create') {
        this.action = INAAction.New;
      }
      else // Pass the view state from ina.component.html
      {
        this.action = INAAction.View;
        this.frmIna.disable();
      }
    }
    );
  }


  ngOnInit(): void {
    this.loading = false;
    this.LoadINASchoolEnrollmentSection();
  }

  LoadINASchoolEnrollmentSection() {
    if (this.action == INAAction.Edit || this.action == INAAction.View) {
      let queryParam: string = '?INAId=' + this.inaId + '&StudentId=0&EnrollmentId=0';
      this.inaService.getINA(queryParam).subscribe((x) => {

        this.inaSchoolEnrollmentSelection = JSON.parse(JSON.stringify(x));


        this.selectedSchoolYear = this.inaSchoolEnrollmentSelection.inaSchoolEnrollment.InaSchoolEnrollment.SchoolYear;;
        this.schoolEnrollmentId = this.inaSchoolEnrollmentSelection.inaSchoolEnrollment.InaSchoolEnrollment.SchoolEnrollmentId;
        let termDurationId = this.inaSchoolEnrollmentSelection.inaSchoolEnrollment.InaSchoolEnrollment.TermDurationId;



        this.cacheSchoolEnrollmentSelectionData();

        if (this.inaSchoolEnrollmentSelection.inaSchoolEnrollment.Message.Code == 200) {

          if (this.inaSchoolEnrollmentSelection.inaSchoolEnrollment.InaSchoolEnrollment.StatusTypeId == 2 && this.action != INAAction.View) {
            let createdBySection = this.inaSchoolEnrollmentSelection.inaSchoolEnrollment.Sections.find(sectionId => sectionId.SectionID == 29);

            let followUpQuestion = createdBySection?.Questions.find(question => question.Id == 498);
            let followUpFName, followUpLName, followUpDate;
            followUpQuestion?.lstQuestionValueDataView.forEach(x => {
              if (x.Id == 1587)
                followUpFName = x.Value;
              else if (x.Id == 1588)
                followUpLName = x.Value;
              else if (x.Id == 1589)
                followUpDate = x.Value
            })

            let u: User = this.loginTokenService.getUser();

            if (u.PERSON?.FIRST_NAME == followUpFName && u.PERSON?.LAST_NAME == followUpLName) {
              if (followUpDate != formatDate(new Date(), 'MM/dd/yyyy', 'en')) {
                followUpQuestion?.lstQuestionValueDataView.forEach(x => {
                  if (x.Id == 1587)
                    x.Value = '';
                  else if (x.Id == 1588)
                    x.Value = '';
                  else if (x.Id == 1589)
                    x.Value = '';
                });
              }
            }
            else if (u.PERSON?.FIRST_NAME != followUpFName || u.PERSON?.LAST_NAME != followUpLName) {
              followUpQuestion?.lstQuestionValueDataView.forEach(x => {
                if (x.Id == 1587)
                  x.Value = '';
                else if (x.Id == 1588)
                  x.Value = '';
                else if (x.Id == 1589)
                  x.Value = '';
              });
            }

          }
          /*let section = this.inaSchoolEnrollmentSelection.inaSchoolEnrollment.Sections.find(x => x.SectionID == 29)!
          this.getListQuestionValueData(section, 498, 'Follow-up by').forEach(
            x => {
              if (x.Name == 'First Name')
                this.step = (x.Value == '') ? 12 : this.step;
              else if (x.Name == 'Last Name')
                this.step = (x.Value == '') ? 12 : this.step;
              else if (x.Name == 'Date')
                this.step = (x.Value == '') ? 12 : this.step;

            }
          )*/

          this.studentSchoolEnrollmentService.getSchoolEnrollments(this.studentId).subscribe(x => {
            this.schOriginalEnrollments = x;
            this.results = x;
            this.schOriginalEnrollments.schoolEnrollments = this.schOriginalEnrollments?.schoolEnrollments.filter(x =>
              (x.SCHOOL_ENROLLMENT_DETAILS_ASL.GRADE != 'P0' && x.SCHOOL_ENROLLMENT_DETAILS_ASL.GRADE != 'P1' && x.SCHOOL_ENROLLMENT_DETAILS_ASL.GRADE != 'P2')
            );

            this.filterSchoolEnrollments(this.selectedSchoolYear);

            //set Value
            this.schoolEnrollment.setValue(this.schoolEnrollmentId);
            if (termDurationId == 1)
              this.radioINAILP.setValue("1");
            else if (termDurationId == 2)
              this.radioINAILP.setValue("2");


            this.showSections = true;
            this.loading = false;

            this.loadPastEdit()
          });

        }
      });
    }
    else if (this.action == INAAction.New) {

      this.studentSchoolEnrollmentService.getSchoolEnrollments(this.studentId).subscribe(x => {
        this.loading = false;
        this.schOriginalEnrollments = x;
        this.results = x;
        this.schOriginalEnrollments.schoolEnrollments = this.schOriginalEnrollments?.schoolEnrollments.filter(x =>
          (x.SCHOOL_ENROLLMENT_DETAILS_ASL.GRADE != 'P0' && x.SCHOOL_ENROLLMENT_DETAILS_ASL.GRADE != 'P1' && x.SCHOOL_ENROLLMENT_DETAILS_ASL.GRADE != 'P2')
        );

        this.filterSchoolEnrollments(this.selectedSchoolYear);
      });
    }
  }

  handleError(errorMessage: string) {
    console.error(errorMessage);
  }

  loadPastEdit() {

    console.log("loadPastEdit:", this.inaId);
    let queryParam: string = '?INAId=' + this.inaId;
    this.inaService.getINAHistory(queryParam).subscribe((x: any) => {
      console.log("getInaHistory returned:")
      console.log(x)

      if (x == null) {
          return this.handleError("No history data available.");
      }

      // Check if x is an empty object and handle
      if (typeof x === 'object' && Object.keys(x).length === 0) {
          return this.handleError("Received an empty object. No history data available.");
      }

      this.trackHistories = x;
      this.inaService.setCurrentInaHistorySelectionObject(this.trackHistories);
      console.log("loadPastEdit complete")
    });


  }

  cacheSchoolEnrollmentSelectionData() {
    if (this.inaSchoolEnrollmentSelection.inaSchoolEnrollment.Message.Code == 200) {
      this.inaService.setCurrentInaSelectionObject(this.inaSchoolEnrollmentSelection);
    }
  }

  filterSchoolEnrollments(schoolYear: string) {

    if (schoolYear != '')
      this.schEnrollments = this.schOriginalEnrollments?.schoolEnrollments.filter(x => x.SCHOOL_ENROLLMENT_DETAILS_ASL.SCHOOL_YEAR == schoolYear);

    this.schEnrollments.sort((a, b) => (a.SCHOOL_ENROLLMENT_DETAILS_ASL.SCHOOL_YEAR < b.SCHOOL_ENROLLMENT_DETAILS_ASL.SCHOOL_YEAR ? -1 : 1));

    if (this.schEnrollments.length === 1) {
      this.schoolEnrollmentId = this.schEnrollments[0].ID;
      this.schoolEnrollment.setValue(this.schoolEnrollmentId);
    }
  }
  schoolYearEvent(schoolYear: string) {
    this.selectedSchoolYear = schoolYear;
    if (this.schOriginalEnrollments?.schoolEnrollments.length > 0)
      this.filterSchoolEnrollments(this.selectedSchoolYear);
  }

  getSectionData(sectionId: number) {
    return this.inaSchoolEnrollmentSelection.inaSchoolEnrollment.Sections.find(x => x.SectionID)!;
  }
  enableCreateButton() {
    return this.frmIna.valid;
  }

  createform() {
    this.loading = true;

    //{"dv":{"StudentId":"1318526","SchoolYear":"2022-23","SchoolEnrollmentId":18011459,"TermDurationId":1,"StatusTypeId":1}}
    let param: any = {
      "StudentId": this.studentId,
      "SchoolYear": this.selectedSchoolYear,
      "SchoolEnrollmentId": this.schoolEnrollment.value,
      "TermDurationId": this.radioINAILP.value,
      "StatusTypeId": 1
    };
    this.inaService.createINA(param).subscribe(x => {

      this.inaSchoolEnrollmentSelection = JSON.parse(JSON.stringify(x));
      if (this.inaSchoolEnrollmentSelection.inaSchoolEnrollment.Message.Code == 200) {
        this.inaService.updateINA(this.inaSchoolEnrollmentSelection.inaSchoolEnrollment).subscribe((x) => {
          this.loading = false;
          this.router.navigateByUrl('/children/' + this.studentId + '/ina/' + this.inaSchoolEnrollmentSelection.inaSchoolEnrollment.InaSchoolEnrollment.Id + '/edit');
        });
      }
      else {
        this.loading = false;
      }
    });
  }

  setStartingSchoolYearDate() {
    // Set the cut-off day to go to next school year (the week after the 3rd Friday in Sept)
    let mDate = moment({ month: 8, day: 1 }); // month is 0 based

    // By default we will need to add two weeks to the first friday
    let nWeeks = 2;
    let month = mDate.month();

    // Get first Friday of the first week of the month
    mDate = mDate.date(1).day(5);

    // Check if first Friday is in the given month
    //  it may have gone to the previous month
    if (mDate.month() != month) {
      nWeeks++;
    }

    this.startingSchoolYearDate = mDate.add(nWeeks, 'weeks').add(3, 'days').toDate();
  }


  showBasedOnGrade(compName: number): boolean {
    if (compName == 1) {
      //personal Information
      return true
    }
    else if (compName == 2) {
      if (this.inaSchoolEnrollmentSelection) {
        let grade: string = this.inaSchoolEnrollmentSelection.inaSchoolEnrollment.InaSchoolEnrollment.Grade;
        let eligibileGrades: string[] = ['P3', 'P4', 'P5', 'TK', 'K', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
        return (eligibileGrades.indexOf(grade) >= 0)
      }
      return false;
    }
    else if (compName == 3) {
      return true;
    }
    else if (compName == 4) {
      let grade: string = this.inaSchoolEnrollmentSelection.inaSchoolEnrollment.InaSchoolEnrollment.Grade
      let eligibileGrades: string[] = ['P3', 'P4', 'P5', 'TK'];
      return (eligibileGrades.indexOf(grade) >= 0)
    }
    else if (compName == 5) {
      let grade: string = this.inaSchoolEnrollmentSelection.inaSchoolEnrollment.InaSchoolEnrollment.Grade
      let eligibileGrades: string[] = ['K', '01', '02', '03', '04', '05', '06', '07', '08'];
      return (eligibileGrades.indexOf(grade) >= 0)
    }
    else if (compName == 6) {
      let grade: string = this.inaSchoolEnrollmentSelection.inaSchoolEnrollment.InaSchoolEnrollment.Grade
      let eligibileGrades: string[] = ['09', '10', '11', '12', 'AD'];
      return (eligibileGrades.indexOf(grade) >= 0)
    }
    else if (compName == 7 || compName == 8) {
      let grade: string = this.inaSchoolEnrollmentSelection.inaSchoolEnrollment.InaSchoolEnrollment.Grade
      let eligibileGrades: string[] = ['NA', 'AD'];
      return (eligibileGrades.indexOf(grade) >= 0)
    }
    else if (compName == 9 || compName == 10 || compName == 11 || compName == 12)
      return true;

    else return false;


  }

  /*prevOrNextStep(sA: StepAction) {


    if (sA.action == '') {
      this.step =  this.step; 
    }    
    else if (sA.action == 'Prev') {
      let i: number;
      for (i = sA.stepNumber; i >= 2; i--) {
        if (this.showBasedOnGrade(i - 1)) {
          this.step = i - 1;
          break;
        }
      }

    }
    else if (sA.action == 'Next') {
      let i: number;
      if (sA.stepNumber == 12) {
        this.step = 0;
      }
      for (i = sA.stepNumber; i <= 11; i++) {
        if (this.showBasedOnGrade(i + 1)) {
          this.step = i + 1;
          break;
        }
      }
    }
    this.updateCacheSections(sA);


  }*/

  updateTrackingHistory(trackH: TrackingHistory) {

    let u: User = this.loginTokenService.getUser();
    trackH.ChangedBy = u.USER_ID!.toString();

    trackH.ChangedDate = formatDate(new Date(), 'M/d/yy, h:mm:ss a', 'en');
    trackH.ChangedFormId = this.inaSchoolEnrollmentSelection.inaSchoolEnrollment.InaSchoolEnrollment.Id;
    this.lstTrackHistory = this.lstTrackHistory.filter(x => x.ChangedField != trackH.ChangedField);
    this.lstTrackHistory.push(trackH);

    if (this.inaSchoolEnrollmentSelection.inaSchoolEnrollment.InaSchoolEnrollment.StatusTypeId == 2) {
      let foundIna = this.inaFormValid.find(x => x.name == 'Create/Follow');
      if (foundIna?.validator) {
        if (this.lstTrackHistory.length >= 1) {
          let tempTrackHistory: TrackingHistory[] = [];
          tempTrackHistory.push(...this.lstTrackHistory);
          this.lstTrackHistory = [];
          this.inaService.createINAHistory(tempTrackHistory).subscribe((inaHistoryResponse: any) => {
            this.trackHistories.inaHistory.push(...tempTrackHistory);
            this.inaService.setCurrentInaHistorySelectionObject(this.trackHistories);
          })
        }
      }
    }
  }
  updateSection(inaAction: INAAction) {
    this.inaService.updateINA(this.inaSchoolEnrollmentSelection.inaSchoolEnrollment).subscribe((inaUpdateResponse: any) => {
      if (inaUpdateResponse.status == 200) {
        if (this.lstTrackHistory.length >= 1) {
          this.inaService.createINAHistory(this.lstTrackHistory).subscribe((inaHistoryResponse: any) => {
            this.trackHistories.inaHistory.push(...this.lstTrackHistory);
            this.inaService.setCurrentInaHistorySelectionObject(this.trackHistories);
            this.lstTrackHistory = [];
          })
        }
        this.loading = false;
        //this.showProgress=false;        

        if (inaAction == INAAction.New && this.inaSchoolEnrollmentSelection.inaSchoolEnrollment.InaSchoolEnrollment.StatusTypeId == 2) {
          this.router.navigateByUrl('/children/' + this.studentId + '/ina/' + this.inaSchoolEnrollmentSelection.inaSchoolEnrollment.InaSchoolEnrollment.Id + '/view');
        }
        else {
          //
        }
      }
    });
  }

  openStatusBar() {
    this._snackBar.open('Saving in Completed Status', 'INA/ILP', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000
    });
  }
  updateChildInfo() {
    let msg = 'The previous Child Information will be overwritten';
    let showCancelBtn = true;
    const dialogRef = this.dialog.open(ConfirmChangesComponent, {
      width: '500px',
      data: { msg: msg, showCancelBtn: showCancelBtn }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result['closed'] == true) {
        this.callInaServiceUpdateSections();
      }
      else {
        return;
      }
    });
  }

  callInaServiceUpdateSections() {
    //let queryParam: string = '?INAId=' + this.inaId + '&StudentId=0&EnrollmentId=0';

    let queryParam: string = '?INAId=0&StudentId=' + this.studentId + '&EnrollmentId=' + this.schoolEnrollmentId;

    this.inaService.getINA(queryParam).subscribe((x) => {
      let update_INA: boolean = false;
      let updatedSchoolEnrollments: InaSchoolEnrollmentSelection = JSON.parse(JSON.stringify(x));

      updatedSchoolEnrollments.inaSchoolEnrollment.Sections?.forEach(updatedSec => {

        let section = this.inaSchoolEnrollmentSelection.inaSchoolEnrollment.Sections.find(x => x.SectionID == updatedSec.SectionID);
        if (section) {
          section.Questions = updatedSec.Questions;
          update_INA = true;
        }

        /*        this.inaSchoolEnrollmentSelection.inaSchoolEnrollment.Sections.forEach(element => {
                  if (element.SectionID == updatedSec.SectionID) {            
                    element = updatedSec;            
                    update_INA = true;
                  }
                });*/
      });

      if (update_INA) {
        this.inaService.setCurrentInaSelectionObject(this.inaSchoolEnrollmentSelection);
        this.updateSection(INAAction.NoAction);
      }

    });

  }


  validateForm(valid: boolean, compName: number) {
    if (compName == 6) {
      this.inaFormValid = this.inaFormValid.filter(x => x.name != 'Secondary');
      this.inaFormValid.push({ name: 'Secondary', validator: valid });
    }
    if (compName == 8) {
      this.inaFormValid = this.inaFormValid.filter(x => x.name != 'OSY');
      this.inaFormValid.push({ name: 'OSY', validator: valid });
    }
    if (compName == 9) {
      this.inaFormValid = this.inaFormValid.filter(x => x.name != 'Health');
      this.inaFormValid.push({ name: 'Health', validator: valid });
    }
    if (compName == 10) {
      this.inaFormValid = this.inaFormValid.filter(x => x.name != 'Learning');
      this.inaFormValid.push({ name: 'Learning', validator: valid });
    }
    if (compName == 11) {
      this.inaFormValid = this.inaFormValid.filter(x => x.name != 'Interviewee');
      this.inaFormValid.push({ name: 'Interviewee', validator: valid });
    }
    if (compName == 12) {
      this.inaFormValid = this.inaFormValid.filter(x => x.name != 'Create/Follow');
      this.inaFormValid.push({ name: 'Create/Follow', validator: valid });
    }

  }

  enableCompleteButton(): boolean {
    let retVal = false;
    //console.log(this.inaFormValid);
    this.inaFormValid?.forEach((x) => {
      if (x.validator == false) {
        retVal = true;
      }
    })
    return retVal;

  }


  editCompletedINAForm() {

    if (this.inaSchoolEnrollmentSelection.inaSchoolEnrollment.InaSchoolEnrollment.StatusTypeId == 1) {
      return true;
    }
    else if (this.inaSchoolEnrollmentSelection.inaSchoolEnrollment.InaSchoolEnrollment.StatusTypeId == 2) {
      let foundIna = this.inaFormValid.find(x => x.name == 'Create/Follow');
      if (foundIna) {
        return foundIna.validator;
      }
    }
    return false;
  }

  saveCompleteform() {
    this.loading = true;
    this.openStatusBar();
    this.inaSchoolEnrollmentSelection.inaSchoolEnrollment.InaSchoolEnrollment.StatusTypeId = 2;

    this.updateSection(INAAction.New);
  }

  fnInitializeProgressSpinner(iCount: number, isPdf: boolean) {
        this.progressMax = iCount;
        let numResults: ProgressSpinnerSet = {
            progressMax: this.progressMax,
            progressCurrentValue: this.progressCurrentValue,
            progressValue: this.progressValue,
            progressSpeed: this.progressSpeed,
            isPdf: isPdf
        };
        this.utilityService.fnPrepProgressSpinner(numResults);
        this.progressMax = numResults.progressMax;
        this.progressCurrentValue = numResults.progressCurrentValue;
        this.progressValue = numResults.progressValue;
        this.progressSpeed = numResults.progressSpeed;
    }

  downloadXLS(schoolName?: string) {
    console.log('now downloading xls data');

    //this.isLoadingResults = true;
    /* console.log('now download xls');
     console.log(this.tableDataSources[0].data);
     console.log('using schoolName:');
     console.log(schoolName);
     setTimeout(() => {
         this.downloadXLSCore(false, schoolName);
     }, 100);*/
  }

  downloadXLSCore(bViaPost: boolean, schoolName?: string) {
    console.log('now downstreaming XLS file :');

    /*  this.lstAcademicRiskResponse = this.tableDataSources[0].data;
      console.log('with rows:');
      console.log(this.lstAcademicRiskResponse);
      console.log('with school:');
      console.log(schoolName);
      console.log('and schoolyear:');
      console.log(this.currentPerformancePeriod);
      if (schoolName) {
          this.fileNameLabel = schoolName;
      }

      this.progressMax = this.lstAcademicRiskResponse.length;
      console.log('set progressMax at:');
      console.log(this.progressMax);
      this.progressValue = 10;
      this.progressCurrentValue = 10;
      this.progressValue = (1 / this.progressMax) * 100;

      console.log('initial progressValue=');
      console.log(this.progressValue);
      console.log('creating school from: ');
      console.log(this.appSchoolsCode?.selectedSchoolIds);
      console.log('creating school districts from: ');
      console.log(this.appSchoolDistrictCode?.selectedSchoolDistrictIds);

      this.lstSelectedRegion = this.appRegionCode?.selectedRegionIds?.map((num: number) => this.utilityService.CreateRegionFromNumber(num));
      this.lstSelecteddistricts = this.appSchoolDistrictCode?.selectedSchoolDistrictIds?.map((num: number) =>
          this.utilityService.CreateSchoolDistrictFromNumber(num)
      );
      this.lstSelectedschools = this.appSchoolsCode?.selectedSchoolIds.map((num: number) => this.utilityService.CreateSchoolFromNumber(num));

      this.searchParm.bCheckedStyling = this.bCheckedStyling.toString();
      this.strExportFileName = this.currentSetting?.EXPORTFILENAME ?? '';
      let strTemplateName = this.strExportFileName;
      this.searchParm.strExportType = 'XLS';

      try {
          this.lstAcademicRiskResponse = this.tableDataSources.map((item) => item.data).reduce((acc, val) => acc.concat(val), []);

          this.searchParm = this.generatePayload();
          this.searchParm.lstSelectedRegion = JSON.stringify(this.lstSelectedRegion);
          this.searchParm.chosenRegions = this.allRegions.find((region) => region.CODE === this.appRegionCode?.selectedRegionIds[0].toString()); // this.appRegionCode?.selectedRegionIds?.map((num:number) => this.utilityService.CreateRegionFromNumber(num));
          this.searchParm.chosenCounties = this.appCountyCode?.selectedCountyIds.map((num: number) => this.utilityService.CreateCountyFromNumber(num));
          this.searchParm.chosenSchools = this.appSchoolsCode?.selectedSchoolIds.map((num: number) => this.utilityService.CreateSchoolFromNumber(num));
          this.selectedSchoolYear = this.currentPerformancePeriod;

          this.searchParm.chosenSchoolDistricts = this.allDistricts.find(
              (district) => district.DISTRICTS === this.appSchoolDistrictCode?.selectedSchoolDistrictName?.toString()
          ); //this.lstSelecteddistricts;
          this.searchParm.schoolYear = this.selectedSchoolYear;
          this.searchParm.schools = this.lstAcademicRiskResponse;
          this.searchParm.Template_Name = strTemplateName;

          this.searchParm.strFileName = strTemplateName;
          this.searchParm.fileNameLabel = this.fileNameLabel;
          this.searchParm.bCheckedStyling = this.bCheckedStyling.toString();

          this.searchParm.columns = this.currentSetting?.COLUMNS;
          this.searchParm.columnHeaders = this.currentSetting?.COLUMN_HEADERS ?? 0;
          this.searchParm.columnWidths = this.currentSetting?.COLUMN_WIDTHS ?? 0;
          this.searchParm.file_name_label = this.currentSetting?.TITLE ?? '';
          this.searchParm.reportType = 0;
          this.searchParm.strExportType = 'XLS';
          this.searchParm.isChosenSchool = false;

          setTimeout(() => {
              console.log('passing searchParm');
              console.log(this.searchParm);

              const progressInterval = setInterval(() => {
                  if (this.progressCurrentValue <= this.progressSpinnerMax) {
                      // this corresponds to 100% of the spinner rotation
                      this.progressCurrentValue += 1;
                      this.progressValue = (this.progressCurrentValue / this.progressMax) * 100;
                      */
    /* console.log("cur value is: ")
        console.log(this.progressValue)
        console.log(this.progressCurrentValue)*/
    /*} else {

        clearInterval(progressInterval);
    }
}, this.progressSpeed); // spinner speed, smaller value=faster

let chosenRegions: number[] = this.chosenRegions.map((item) => item.ID ?? 0);
let chosenCounties: number[] = this.chosenCounties.map((item) => item.ID ?? 0);
let chosenSchoolDistricts: number[] = this.chosenSchoolDistricts.map((item) => item.ID ?? 0);
let chosenSchools: number[] = this.chosenSchools.map((item) => item.ID ?? 0);

var params = {
    chosenRegions: chosenRegions,
    chosenCounties: chosenCounties,
    chosenSchoolDistricts: chosenSchoolDistricts,
    chosenSchools: chosenSchools,
    performancePeriod: this.currentPerformancePeriod //this.searchParm.schoolYear,

};

this.searchParm.chosenRegions = params.chosenRegions;
this.searchParm.chosenCounties = params.chosenCounties;
this.searchParm.chosenSchools = params.chosenSchools;
if (schoolName) {
    let chosenSchoolID: number;
    chosenSchoolID = this.findSchoolIDForSchoolName(schoolName);

    console.log('Found schoolID for school:');
    console.log(chosenSchoolID);

    if (chosenSchoolID) {
        this.searchParm.chosenSchools = [chosenSchoolID];
        console.log('chosenSchools set to new deal');
    }

    this.searchParm.isChosenSchool = true;
}
this.searchParm.performancePeriod = params.performancePeriod;

this.apiMsinExportsService.getAcademicRiskPost(this.searchParm);
});
} catch (Err) {
console.log('Error running filestream XLS export: ');
console.log(Err);

}
*/
  }

  generatePayload(): any {
    let payload: any = {};
    /*
            payload.chosenRegions = this.chosenRegions.map((obj) => obj.ID);
            payload.chosenCounties = this.chosenCounties.map((obj) => obj.ID);
            payload.chosenSchoolDistricts = this.chosenSchoolDistricts.map((obj) => obj.ID);
            payload.chosenSchools = this.chosenSchools.map((obj) => obj.ID);
            payload.performancePeriod = this.selectedPerformancePeriod; */

    return payload;
  }

  openPDF(){
    console.log("now opening pdf, looking for filenames: ")
    console.log(this.currentSetting?.EXPORTFILENAME);
    console.log(this.currentSetting?.TITLE)

    if (this.latestFileToOpen?.length > 0)
    {
      console.log("opening directly")
      window.open(`${this.latestFileToOpen}.pdf`, '_blank');

    }
    else
    {
      console.log("downloading first then opening")
      console.log(this.latestFileToOpen)
        this.downloadPdfCore(false, true, "" );
        window.open(this.latestFileToOpen, '_blank');
    }
  }

  downloadPDF(schoolName?: string) {
    this.downloadPdfCore(false, false, schoolName );
  }

  downloadPdfCore(bRegional: boolean, bOpen: boolean, schoolName?: string) {
    console.log('now downstreaming PDF file');

    //console.log('with rows:');
    //console.log(this.schEnrollments.length); 

    this.lpRecommendedServices = this.learningplan?.lstInstructionalService ?? [];
    this.lpRecommendedSupportServices = this.learningplan?.lookupSupportService ?? [];
    // console.log(this.learningplan.lstSupportService.length);
    // activate spinner
    this.loading = true;

    this.searchParm = this.generatePayload();
    this.searchParm.bCheckedStyling = this.bCheckedStyling.toString();

    this.strExportFileName = "INA_ILP";
    let strTemplateName = this.strExportFileName;
    this.searchParm.strExportType = 'PDF';

    // custom fileNameLabel = schoolperiod_Grade_MSDNum
    let msdNum: string = this.inaSchoolEnrollmentSelection.inaSchoolEnrollment.Sections[0].Questions.find(q => q.Name == "MSD")?.lstQuestionValueDataView[0].Value.toString() ?? "";
    let schoolPeriod: string = this.selectedSchoolYear;
    let grade: string = this.inaSchoolEnrollmentSelection.inaSchoolEnrollment.Sections[0].Questions.find(q => q.Name == "Grade")?.lstQuestionValueDataView[0].Value.toString() ?? "";
    this.fileNameLabel = `${schoolPeriod}_${grade}_${msdNum}`;
    try {
      this.searchParm.schoolYear = this.selectedSchoolYear;
      this.searchParm.inaSchoolEnrollment = this.inaSchoolEnrollmentSelection.inaSchoolEnrollment;
      this.searchParm.schoolEnrollment = this.schOriginalEnrollments.schoolEnrollments;
      this.searchParm.Template_Name = strTemplateName;

      this.searchParm.strFileName = strTemplateName;
      this.searchParm.fileNameLabel = this.fileNameLabel;
      this.searchParm.bOpen = bOpen.toString();
      this.searchParm.file_name_label = this.currentSetting?.TITLE ?? '';
      this.searchParm.reportType = 1;

      this.searchParm.lpRecommendedServices = this.lpRecommendedServices;
      this.searchParm.lpRecommendedSupportServices = this.lpRecommendedSupportServices;

      setTimeout(() => {
        //console.log('passing searchParm');
        //console.log(this.searchParm);
        this.loading = true;
       
        //console.log('now calling http post with params:');
        this.apiMsinExportsService.getInaPdfPost(this.searchParm).then(
          filename => {
            console.log("filename to open:")
            console.log(filename)
            this.latestFileToOpen = filename;
            this.loading = false;
          }
        ).catch (() =>
        {
          this.loading = false;
        })
      });

    } catch (Err) {
      console.log('Error running filestream PDF export: ');
      console.log(Err);
      console.log("hid spinner2")
      this.loading = false;
    }
  }

  getListQuestionValueData(s: Section, questionId: number, questionName: string): LstQuestionValueDataView[] 
  {
    return this.shared.getListQuestionValueData(s, questionId, questionName);
  }

  get schoolYears(): any { return this.frmIna.get('schoolYears'); }
  get schoolEnrollment(): any { return this.frmIna.get('schoolEnrollment'); }
  get radioINAILP(): any { return this.frmIna.get('radioINAILP'); }

}
type INAFormValid = { name: string, validator: boolean };
